export type ThemeColors = {
  background: string
  surface: string
  primary: string
  dark: string
  white: string
  muted: string
  border: string
}

export const lightColors: ThemeColors = {
  background: '#f4f1ed',
  surface: '#ffffff',
  primary: '#E8732A',
  dark: '#1a1a1a',
  white: '#ffffff',
  muted: '#888888',
  border: '#e0e0e0',
}

export const darkColors: ThemeColors = {
  background: '#121214',
  surface: '#1e1e22',
  primary: '#E8732A',
  dark: '#f0ece4',
  white: '#ffffff',
  muted: '#9ca3af',
  border: '#2e2e34',
}

// Backward-compat alias — remove once all screens use useThemeColors()
export const colors = lightColors

export const fontSize = {
  xs: 13,
  sm: 15,
  md: 17,
  lg: 19,
  xl: 22,
  '2xl': 30,
  '3xl': 38,
}

export const spacing = {
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 48,
}

export const fonts = {
  regular: 'Outfit',
  medium: 'Outfit-Medium',
  semibold: 'Outfit-SemiBold',
  bold: 'Outfit-Bold',
}
